import React, { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { Breadcrumb, Button, Space, Tabs } from 'antd'
import SoftCourseList from './SoftCourseList'
import SoftBuy from './SoftBuy'
import { useGwGoodsUpdateQuery } from '../store/ReactWebSiteApi'
import SoftSpec from './SoftSpec'
import WebMain from './WebMain'
import { H5 } from './h5Routes'

function SoftDesc() {
    const navi = useNavigate()
    const [param] = useSearchParams()
    const id = param.get('id')
    const [info, setInfo] = useState({
        eowg_content: '',
    })
    const { data, isSuccess } = useGwGoodsUpdateQuery({ eowg_id: id })
    useEffect(() => {
        if (isSuccess) {
            if (data.Status === 'success') {
                setInfo((prev) => ({
                    ...prev,
                    eowg_name: data.Result.eowg_name,
                    eowg_dept_id: data.Result.eowg_dept_id,
                    eowg_content: data.Result.eowg_content,
                    eowg_dept_name: data.Result.eowg_dept_name,
                    eowg_image_file: data.Result.eowg_image_file,
                    eowg_luyou: data.Result.eowg_luyou,
                    eowg_state: data.Result.eowg_state,
                    eowg_goods: data.Result.eowg_goods,
                    eowg_bg_id: data.Result.eowg_bg_id,
                }))
            }
        }
    }, [data, isSuccess])
    const items = [
        {
            label: '详情',
            key: 'intro',
            children: (
                <div style={{ fontSize: 14, width: '100%', maxWidth: '100%', overflowX: 'auto' }} dangerouslySetInnerHTML={{ __html: info.eowg_content }} />
            ),
        },
        {
            label: '教程',
            key: 'organ',
            children: <SoftCourseList bjc_bgn_id={id} />,
        },
        {
            label: '购买',
            key: 'id',
            children: <SoftBuy bsg_bg_id={info.eowg_bg_id} bsg_bgn_id={id} />,
        },
    ]
    return (
        <WebMain selectedKeys="">
            <div style={{ padding: '12px', background: '#fff' }}>
                <Breadcrumb
                    style={{ margin: '12px 0', fontSize: 13 }}
                    items={[
                        {
                            title: (
                                <a
                                    onClick={() => navi(H5.GOODS)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    全部产品
                                </a>
                            ),
                        },
                        { title: info.eowg_name },
                    ]}
                />
                <div style={{ fontSize: 18, display: 'flex', flexDirection: 'column', gap: 16, width: '100%' }}>
                    <img
                        src={`/api/assets/images/application/${info.eowg_image_file}`}
                        alt=""
                        style={{ width: '100%', maxWidth: 280, border: '2px solid #eee', alignSelf: 'center' }}
                    />
                    <Space direction="vertical" size={12} style={{ width: '100%' }}>
                        <div style={{ fontWeight: 600 }}>{info.eowg_name}</div>
                        <SoftSpec eowgg_eowg_id={id} />
                        <Button
                            type="primary"
                            size="large"
                            block
                            onClick={() => {
                                window.open(info.eowg_luyou)
                            }}
                        >
                            免费试用
                        </Button>
                    </Space>
                </div>
                <div style={{ padding: '12px 0' }}>
                    <Tabs items={items} size="middle" type="card" />
                </div>
            </div>
        </WebMain>
    )
}

export default SoftDesc
